import React, {useRef, useEffect} from 'react'
import naverMapIcon from '../images/naver.webp';
import kakaoMapIcon from '../images/kakao.png';

function Location() {
  const mapRef = useRef(null);
  const lat = 37.5582197; // 위도
  const lng = 127.0344612; // 경도

  useEffect(() => {
    const { naver } = window;
    if (mapRef.current && naver) {
      const location = new naver.maps.LatLng(lat, lng);
      const map = new naver.maps.Map(mapRef.current, {
        center: location,
        zoom: 15, // 지도 확대 정도
      });
      new naver.maps.Marker({
        position: location,
        map,
      });
    }
  }, []);

  const gotoNavermap = () => {
    // window.location.href = 'https://map.naver.com/p/entry/place/13355252'
    window.open("https://map.naver.com/p/entry/place/13355252")
  }

  const gotoKakaomap = () => {
    // window.location.href = 'https://place.map.kakao.com/24718969'
    window.open("https://place.map.kakao.com/24718969")
  }
  

  return (
    <div className='container'>
    <div className='title'>오시는 길</div>
    <div className='location__details'>
      <div>레노스블랑쉬 왕십리</div>
      <div>서울 성동구 고산자로 202, 2층 블랑쉬홀</div>
    </div>
    <div ref={mapRef} className='location__map'></div>
    <div className='location__map-icon-box'>
        <div className='location__map-item' onClick={gotoNavermap}>
          <img src={naverMapIcon} className='location__map-icon' alt="naverMap"/>
          <span>네이버지도</span>
        </div>
        <div className='location__map-item' onClick={gotoKakaomap}>
          <img src={kakaoMapIcon} className='location__map-icon' alt='kakaoMap'/>
          <span>카카오지도</span>
        </div>
    </div>
   <div className='location__info'>
    <div>왕십리역(2호선)</div>
    <div>9번 출구에서 310m</div>
   </div>
</div>
  )
}


export default Location
